import React, { ReactNode, useEffect } from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";
import { useAppLayout } from "@dataone/lib";

interface MyModalProps {
  modalTitle: string;
  open: boolean;
  confirmLoading: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  handleGoBack?: () => void;
  handleAddMore?: () => void;
  children?: ReactNode;
  current: number;
  isDeleteModal?: boolean;
  failed: boolean;
  formMode?: string;
  containerId: string;
}

const DataSourceModal: React.FC<MyModalProps> = ({
  modalTitle,
  open,
  confirmLoading,
  handleOk,
  handleCancel,
  handleGoBack,
  children,
  current,
  isDeleteModal,
  failed,
  formMode,
  containerId,
  handleAddMore,
}) => {
  const bodyHeight = isDeleteModal ? "auto" : "520px";

  const { isSmartSearchVisible } = useAppLayout();

  useEffect(() => {
    if (isSmartSearchVisible) handleCancel();
  }, [isSmartSearchVisible]);

  return (
    <StyledModal
      destroyOnClose
      getContainer={containerId}
      open={open}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      width={isDeleteModal ? "40%" : "100%"}
      styles={{
        body: { minHeight: bodyHeight },
        mask: {
          position: "absolute",
          borderRadius: "20px 40px 40px 40px",
        },
      }}
      wrapClassName="absolute-modal-wrap"
      className="modal-container"
      footer={[
        handleGoBack && current !== 0 && current !== 2 && (
          <Button
            className={
              failed
                ? "only-previous-button"
                : formMode === "update"
                ? "hide-previous-button"
                : "previous-button"
            }
            key="cancel"
            onClick={handleGoBack}
          >
            Previous
          </Button>
        ),
        current === 2 && (
          <>
            {formMode === "create" && (
              <Button className="add-more-button" onClick={handleAddMore}>
                Add more
              </Button>
            )}

            <Button
              type="primary"
              className="done-button"
              key="done"
              onClick={handleCancel}
            >
              Done
            </Button>
          </>
        ),
      ]}
    >
      <div className={`${isDeleteModal ? "delete-modal" : "modal-content "}`}>
        <StyledSubHeader>
          <div className="sub-header">
            <h2 className={isDeleteModal ? "deleted-title" : ""}>
              {modalTitle}
            </h2>
          </div>
        </StyledSubHeader>
        <StyledChildren>{children}</StyledChildren>
      </div>
    </StyledModal>
  );
};

const StyledSubHeader = styled.div`
  .sub-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: -60px;
  }
  h2 {
    color: #4974f6;
    font-weight: 700;
    font-size: 18px;
    padding: 20px 0px;
  }
  .deleted-title {
    color: #4974f6;
    text-align: center;
    font-size: 30px;
    font-weight: 700;
  }
  .app-icon {
    margin-top: -10px;
  }
  .app-icon:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }
`;
const StyledChildren = styled.div`
  // height: 500px;
  // overflow-y: auto;
`;

const StyledModal = styled(Modal)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-content {
    padding: 30px 30px 5px 28px;
  }
  .delete-modal {
    padding-top: 30px;
  }
  .ant-modal-content {
    min-width: 300px;
    width: 70vw;
    padding: 15px 10px;
  }
  .ant-modal-close-x .anticon svg {
    margin-right: 40px;
    margin-top: 10px;
  }
  span.anticon.anticon-close.ant-modal-close-icon {
    background-color: white;
  }
  .previous-button {
    right: 140px;
    background: #eff1fd;
    transition: right 0.1s;
    border: none !important;
    color: #040726 !important;
    font-size: 13px;
  }
  .only-previous-button {
    right: 0px;
    background: #eff1fd;
    border: none !important;
    color: #040726 !important;
    font-size: 13px;
  }
  .hide-previous-button {
    display: none;
  }
  .done-button {
    position: absolute;
    right: 40px;
    bottom: 20px;
    border-radius: 6px;
    background: #4974f6;
    font-size: 13px;
  }
  .add-more-button {
    position: absolute;
    right: 110px;
    bottom: 20px;
    border-radius: 6px;
    border: none !important;
    background: #eff1fd !important;
    color: #040726 !important;
    font-size: 13px;
  }
`;

export default DataSourceModal;
